import React, { useState } from 'react';
import { Chip, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate } from 'react-router-dom';

const dashboards = ['Main', 'Civils', 'Procurement', 'Accounting', 'Qs', 'Architecture'];

export default function DashboardSwitcher({ current, onChange }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (dashboard) => {
        onChange(dashboard);
        handleClose();
        if (dashboard === 'Main') {
            navigate('/dashboard/default');
        } else {
            navigate(`/${dashboard.charAt(0).toLowerCase() + dashboard.slice(1)}`);
        }
    };

    return (
        <>
            <Chip
                label={current}
                onClick={handleOpen}
                icon={<ArrowDropDownIcon />}
                color="primary"
                variant="outlined"
                sx={{ cursor: 'pointer', fontWeight: 600, ml: 2 }}
            />

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                {dashboards.map((dash) => {
                    const label = (dash === 'Civils' && 'Civils Engineering') || (dash === 'Qs' && 'Quantity Surveyors') || dash;
                    return (
                        <MenuItem key={dash} selected={dash === current} onClick={() => handleSelect(dash)}>
                            {label}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
}
